import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { SMC_THEMES, DEFAULT_SMC_THEME, applyThemeCSSVars } from './themes';
import { TOKENS } from './tokens';

export const ThemeContext = createContext({
  themeId: DEFAULT_SMC_THEME,
  theme: SMC_THEMES[DEFAULT_SMC_THEME],
  setTheme: () => {},
  tokens: TOKENS
});

export function ThemeProvider({ children, initialTheme }) {
  const [themeId, setThemeIdState] = useState(() => {
    const stored = localStorage.getItem('smc_theme');
    return initialTheme || stored || DEFAULT_SMC_THEME;
  });

  useEffect(() => {
    applyThemeCSSVars(themeId);
  }, [themeId]);

  const setTheme = useCallback(async (newId, uid, db) => {
    if (!SMC_THEMES[newId]) return;
    setThemeIdState(newId);
    localStorage.setItem('smc_theme', newId);
    if (uid && db) {
      try {
        const { doc, updateDoc } = await import('firebase/firestore');
        await updateDoc(doc(db, 'authorized_users', uid), { theme: newId });
      } catch (_) {}
    }
  }, []);

  return (
    <ThemeContext.Provider value={{
      themeId,
      theme: SMC_THEMES[themeId] || SMC_THEMES[DEFAULT_SMC_THEME],
      setTheme,
      tokens: TOKENS
    }}>
      {children}
    </ThemeContext.Provider>
  );
}
